<template>
    <el-row type="flex" justify="center">
        <el-col :md="8" :xs="20" :sm="20" :lg="8">

            <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="80px" class="demo-ruleForm">
                <el-form-item label="手机号" prop="phone_num">
                    <el-input v-model.number="ruleForm2.phone_num"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="pass">
                    <el-input type="password" v-model="ruleForm2.pass" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm2')">登录</el-button>
                    <el-button type="text" @click="pageToRegister">注册-></el-button>
                </el-form-item>
            </el-form>
        </el-col> 
    </el-row>
</template>
<script>
import axios from 'axios';
import config from './config.js';
export default {

    data() {
        var checkphone_num = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('手机号不能为空'));
            }
            setTimeout(() => {
                
                    if (!this.isPoneAvailable(value)) {
                        callback(new Error('请输入正确的手机号'));
                    } else {
                        callback();
                    }
                
            }, 1000);
        };
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } 
            callback()
        };
       
        return {
            ruleForm2: {
                pass: '',
                phone_num: ''
            },
            rules2: {
                pass: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                phone_num: [
                    { validator: checkphone_num, trigger: 'blur' }
                ]
            }
        };
    },
    created(){
        let phone_num = localStorage.getItem('phone_num')
        if(phone_num){
            this.ruleForm2.phone_num = phone_num
        }
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    //alert('submit!');
                    let _this = this;
                     axios({
                        method: 'post',
                        url: config.base_url + '/yun_table/users/login',
                        data: {
                            phone_num: _this.ruleForm2.phone_num,
                            passwd: _this.ruleForm2.pass
                        }
                    })
                    .then(function(response) {
                        //console.log(response.data)
                        localStorage.setItem('token', response.data.token)
                        localStorage.setItem('phone_num', response.data.phone_num)
                        localStorage.setItem('login', true)
                        _this.$message({
                            message: '登录成功',
                            type: 'success'
                        });
                        _this.$router.go(-1)
                    })
                    .catch((err) => {
                        //console.log(err.response)
                        let err_data = err.response.data.err_msg
                        this.$message({
                            message: err_data,
                            type: 'error'
                        })
                    })

                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        isPoneAvailable: function(pone) {
                var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
                if (!myreg.test(pone)) {
                    return false;
                } else {  return true;
            }
        },
        pageToRegister() {
            this.$router.push({
                    path: '/register'
            })
        }
    }
}
</script>